import { find, isNil } from 'lodash'

export const removeById = (array, id) => {
    let obj = find(array, { id: id })

    if (typeof obj === 'undefined') return

    let index = array.indexOf(obj)
    array.splice(index, 1)

    return array
}

export const removeByIndex = (array, index) => array.splice(index, 1)

export const removeItem = (array, id) => {
    let index = array.indexOf(id)
    array.splice(index, 1)

    return array
}

export const replaceItem = (array, item) => {
    if (!isNil(find(array, { id: item.id })))
        removeById(array, item.id)

    array.push(item)
}



// WEBPACK FOOTER //
// ./src/utils/helpers/arrays.js